import InvoiceInterface from "../interface/invoiceInterface";
import React from "react";
import MarketRepository from "../../Main/repository/MarketRepository";
import MarketCartLocalstorage from "../../Main/interface/MarketCartLocalstorage";
import {find, get, toNumber} from "lodash";
import MarketSettingLocalStorage from "../../Main/interface/MarketSettingLocalStorage";
import AppSettingController from "../../Main/controller/AppSettingController";
import PaymentManager from "./PaymentManager";
import {NavigateFunction} from "react-router-dom";
import AppCartController from "../../Main/controller/AppCartController";
import i18n from "../../../i18n";

export default class DiscountController {
    protected state: InvoiceInterface;
    protected setState: React.Dispatch<React.SetStateAction<InvoiceInterface>>;

    constructor(state: InvoiceInterface, setState: React.Dispatch<React.SetStateAction<InvoiceInterface>>) {
        this.state = state;
        this.setState = setState;
    }

    clearDiscount() {
        const priceSum = AppCartController.priceSum();
        this.updateState({
            discount: {
                show: false,
                isApplyDiscount: false,
            },
            price: {
                total: priceSum,
                regular: priceSum,
            }
        })
    }

    static getDiscount(state: InvoiceInterface): number {
        if (!state.discount.isApplyDiscount) return 0

        if (state.discount.type === 'price')
            return toNumber(state.discount.discountPrice);

        return state.price.regular * (toNumber(state.discount.discountPercentage) / 100)
    }

    discountCalculation(e?: any) {
        if (e) e.preventDefault();
        const setting = AppSettingController.getSetting() as MarketSettingLocalStorage;
        const priceSum = AppCartController.priceSum();
        const extraCostsPrice = AppCartController.extraCostsPrice();
        const discountCode = find(setting.discount, {discountCode: this.state.discount.code}) as MarketSettingLocalStorage['discount']

        if (!discountCode)
            return this.updateState({
                error: {
                    status: true,
                    message: i18n.t("invoice.invalidDiscountCode")
                }
            })

        this.updateState({
            discount: {
                show: false,
                isApplyDiscount: true,
                id: get(discountCode, "id"),
                code: get(discountCode, "discountCode"),
                discountPercentage: get(discountCode, "discountPercentage"),
                discountPrice: get(discountCode, "discountPrice"),
                discountPriceSeparator: get(discountCode, "discountPriceSeparator"),
                type: get(discountCode, "type"),
            },
        })

        if (get(discountCode, "type") === "price")
            return this.updateState({
                price: {
                    regular: priceSum,
                    total: priceSum + extraCostsPrice - toNumber(get(discountCode, "discountPrice")) < 0 ? 0 : priceSum + extraCostsPrice - toNumber(get(discountCode, "discountPrice")),
                }
            })


        if (get(discountCode, "type") === "percentage")
            return this.updateState({
                price: {
                    regular: priceSum,
                    total: priceSum + extraCostsPrice - (priceSum * toNumber(get(discountCode, "discountPercentage"))) / 100 < 0 ? 0 : priceSum + extraCostsPrice - (priceSum * toNumber(get(discountCode, "discountPercentage"))) / 100,
                }
            })

        this.updateState({
            price: {
                ...this.state.price,
                regular: priceSum,
            },
            discount: {
                ...this.state.discount,
                show: false,
            },
        })
    }

    toggleFormDiscount(status?: boolean) {
        this.updateState({
            discount: {
                ...this.state.discount,
                show: status ? status : !this.state.discount.show,
            }
        })
    }

    setDiscountCode(value: string) {
        this.updateState({
            discount: {
                ...this.state.discount,
                code: value,
            }
        })
    }

    calculationPrice() {
        const card = MarketRepository.getCartMarket() as MarketCartLocalstorage;
        const priceSum = AppCartController.priceSum();

        this.setState(prev => ({
            ...prev,
            card,
            price: {
                total: priceSum,
                regular: priceSum,
            }
        }))

        if (this.state.discount.isApplyDiscount)
            return this.discountCalculation();
    }

    backToInvoice() {
        this.updateState({
            showPaymentMethod: false,
        })
    }

    async payment(shopId: string, navigate: NavigateFunction, desk: string | undefined, paymentMethod?: 'pos' | 'cash') {
        const setting = AppSettingController.getSetting() as MarketSettingLocalStorage;
        this.updateState({paymentMode: paymentMethod})

        if (setting.marketMode === 'pos-or-cash' && !this.state.showPaymentMethod)
            return this.setState((prevState) => ({...prevState, showPaymentMethod: true}))

        await new PaymentManager(this.state, this.setState).payment(desk, shopId as string, navigate, paymentMethod)
    }

    private updateState(state: Partial<InvoiceInterface>) {
        const newState = {...this.state, ...state};
        this.state = newState;
        this.setState(newState)
    }
}